module.exports = __webpack_public_path__ + "img/hot10.67833545.jpg";